/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color, lightTheme } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';
import moment from 'moment';
import {
  LP,
  calculateNFTWithdrawalTime,
  formatUSD,
  formatUSDNoDecimals,
  walletsNFTWithdraw
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { PackageTrading } from './Portfolio.types';

import { useAppDispatch } from '../../app/hooks';
import { PortfolioItemDisabled } from './PortfolioItemDisabled';

import { useAppSelector } from '../../app/hooks';
import { WithdrawalItemDisabled } from './WithdrawalItemDisabled';
import { TextWithTooltip } from '../../components/common/TextWithTooltip';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDisconnect } from 'wagmi';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { WithdrawStepsEnum } from './WithdrawHubs/types';

interface PortfolioTradingItemProps {
  item: PackageTrading;
  setPackageItem: Dispatch<SetStateAction<PackageTrading | null>>;
  withdrawModal: boolean;
  setWithdrawModal: Dispatch<SetStateAction<boolean>>;
  setSelectedNFTWallet: any;
  transferAssetStatus: boolean;
}

export const PortfolioTradingItem = ({
  item,
  setPackageItem,
  withdrawModal,
  setWithdrawModal,
  setSelectedNFTWallet,
  transferAssetStatus
}: PortfolioTradingItemProps) => {
  const { t } = useTranslation('my_hubs');

  const { disconnect } = useDisconnect();

  const renderExpiryDate = (date: number) => {
    const d = moment(date);
    const year = d.format('YYYY');
    if (Number(year) > 2100) {
      return 'LIFETIME';
    } else return d.format('DD MMM YYYY');
  };

  const showConvertedHub = (item: any) => {
    if (item?.dateConverted) {
      return (
        <PortfolioItemDisabled
          title={'You Have Converted this Hub NFT into Loyalty Points'}
          subtitle={
            <>
              Date of conversion:{' '}
              {moment.utc(item?.dateConverted).format('MMM DD, yyyy')} <br />{' '}
              Loyalty Points Received: {formatUSD(item?.loyaltyPoints)} {LP}
            </>
          }
        />
      );
    }
  };

  const showDisabledTradingHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();
      const hours = fromNow.hours();

      if (days === 0 && hours < 24) {
        return (
          <PortfolioItemDisabled
            title={t('disabled_hub_title')}
            subtitle='It may take up to 24 Hours for Hub NFT to Refresh.'
          />
        );
      }
    }
  };

  const showWithdrawableTradingHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();

      if (days > 0) {
        return <WithdrawalItemDisabled />;
      }
    }
  };

  const showWithdrawNFTButton = (item: any) => {
    if (item?.isWithdrawable && !item?.dateConverted && item?.nftId !== null) {
      return <Flexed column alignEnd></Flexed>;
    } else {
      return (
        calculateNFTWithdrawalTime(item) && (
          <Flexed column alignEnd>
            <Button
              color='#ffffff'
              borderColor='#CC0000'
              background='#CC0000'
              wSM='100%'
              w='200px'
              onClick={() => {}}
              negative={false}>
              TRANSFERRED
            </Button>
          </Flexed>
        )
      );
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage
          image={item?.image}
          isDisabled={calculateNFTWithdrawalTime(item)}>
          <H4 color={color.colors.neutral0}>{item?.name}</H4>
        </HubImage>
        <div>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('price')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSDNoDecimals(item.price)} <P3 mb='1'>USDT</P3>
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.dateOfPurchase).format('DD MMM YYYY')}</P1>
            </Td>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_activation')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {moment(item?.dateOfCreation).format('DD MMM YYYY')}
              </P1>
            </Td>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {/* {t('date_of_purchase')} */}
                DATE OF EXPIRY
              </CaptionText>
              <P1 bold>{renderExpiryDate(item?.expiryDate)}</P1>
            </Td>
            <Td w='20%' wSM='50%'>
              {showWithdrawNFTButton(item)}
            </Td>
          </Tr>
          <div>
            <>
              <Responsive style={{ margin: '24px 0' }} between center>
                <Flexed mbSM='20'>
                  <P3 caps bold color={color.colors.secondary100} mr='60'>
                    {item?.name === 'Annual Membership (1 Year)'
                      ? 'Annual Membership Details'
                      : t('trading_hub_details')}
                  </P3>
                  <P3 flex color={color.colors.secondary100} mr='60'>
                    {t('order_id')}:{' '}
                    <P3 bold ml='2' color={color.colors.secondary100}>
                      {item?.id}
                    </P3>
                  </P3>
                  {item?.packageId !== 146 && (
                    <P3 flex color={color.colors.secondary100}>
                      NFT ID:
                      <P3 bold ml='2' color={color.colors.secondary100}>
                        {item?.nftId}
                      </P3>
                    </P3>
                  )}
                </Flexed>
              </Responsive>
            </>
          </div>
        </div>
        {showConvertedHub(item)}
        {calculateNFTWithdrawalTime(item)
          ? showWithdrawableTradingHub(item)
          : showDisabledTradingHub(item)}

        {/* {showDisabledHub()} */}
      </BoxBig>
    </>
  );
};
